import type { TCounterRowDTO, TStaffEventDTO } from './counters.dto';

import type { TCounters, TStaffEvent } from './counters.types';

const toCounterKey = (bucket: string, key: string): string => `${bucket}:${key}`;

const toCounters = (rows: readonly TCounterRowDTO[]): TCounters => Object
  .fromEntries(rows.map(row => [toCounterKey(row.bucket, row.key), row.total]));

const toStaffEvent = (dto: TStaffEventDTO): TStaffEvent => ({
  id: dto.id,
  action: dto.action,
  entityKind: dto.entity_kind,
  entityID: dto.entity_id,
  actorID: dto.actor_id,
  createdAt: dto.created_at,
});

export {
  toCounterKey,
  toCounters,
  toStaffEvent,
};
